import commitThemeChange from './orchestration/commitThemeChange';
import discardThemeChange from './orchestration/discardThemeChange';
import ThemeFull from './view/ThemeFull';
import ThemeQuick from './view/ThemeQuick';
import isThemePreviewDirty from './utils/isThemePreviewDirty';
import * as React from 'react';
var ThemeOption = {
    key: 'theme',
    titleStringKey: 'optionTitle_Theme',
    searchTermsStringKey: 'optionSearch_Theme',
    fullOptionFormSettings: {
        render: function () { return React.createElement(ThemeFull, null); },
        isDirty: isThemePreviewDirty,
        onSave: commitThemeChange,
        onDiscard: discardThemeChange,
    },
    quickOptionSettings: {
        rendering: {
            render: function () { return React.createElement(ThemeQuick, null); },
        },
        order: 0 /* Theme */,
        workloads: 2415919103 /* All */,
    },
};
export default ThemeOption;
//# sourceMappingURL=ThemeOption.js.map